import React, {useState} from 'react';
import {useParams} from "react-router-dom";
import CompressorDiagram from "../../../components/CompressorDiagram/CompressorDiagram";
import './dataQualityTab.scss';
import DataQualityReportTable from "./DataQualityReport/DataQualityReportGrid";
import {Alert, Box, Button, Modal, Snackbar, Typography} from "@mui/material";
import useDataQualityReport from "../../../hooks/Reports/useDataQualityReport";
import RequestRevisionUpdateForm from "./RequestRevisionUpdateForm/RequestRevisionUpdateForm";
import useCurrentMlinkRevision from "../../../hooks/MlinkFirmwareRevision/useCurrentMlinkRevision";
import {Client} from "../../../autogenerate/api.generated.clients";

function DataQualityTab() {
    const [showUpdateForm, setShowUpdateForm] = React.useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');
    const params = useParams();
    const frameSerialNumber = params.frameSerialNumber!;
    const currentRevision = useCurrentMlinkRevision({frameSerialNumber})
    const dataQualityReport = useDataQualityReport({frameSerialNumber});

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    
    const handleUpdateRequestSubmit = async (frameSerialNumber: string, revisionNumber: string, notes: string) => {
        try {
            await new Client().mlinkFirmware_RequestUpdate({
                frameSerialNumber: frameSerialNumber,
                firmwareRevision: revisionNumber,
                notes: notes
            });
            setSnackbarMessage('Request has been sent. You should hear from our team shortly.');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            setShowUpdateForm(false);
        } catch (error) {
            setSnackbarMessage('There was an error with the request.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        }
    }

    return (
        <div className={"data-quality-tab-container"}>
            <div className={"data-quality-diagram-wrapper"}>
                <Typography variant="h6" className={"diagram-title"}>Current Configuration</Typography>
                <div className="diagram-subtitle">
                    <Typography variant="body2">Need to change the configuration or firmware revision?</Typography>
                    <Button onClick={()=> setShowUpdateForm(true)} variant="text" color="primary" size="small" sx={{textTransform: 'none', fontWeight: 'normal'}}>Request Update</Button>
                </div>
                <div className={"data-quality-diagram"}>
                    <CompressorDiagram frameSerialNumber={frameSerialNumber} isCylindersDisabled={true}
                                       isUnloadersDisabled={true}/>
                </div>
            </div>
            <div>
                <DataQualityReportTable currentRevision={currentRevision.data} data={dataQualityReport.data} isLoading={dataQualityReport.isLoading}/>
            </div>
            <Modal
                open={showUpdateForm}
                onClose={()=>setShowUpdateForm(false)}
                aria-labelledby="update-form-title"
                aria-describedby="update-form-description"
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4 }}>
                    <RequestRevisionUpdateForm frameSerialNumber={frameSerialNumber} currentRevision={currentRevision.data} onCancel={()=>setShowUpdateForm(false)} onSubmit={handleUpdateRequestSubmit}/>
                </Box>
            </Modal>

            <Snackbar open={snackbarOpen} 
                      autoHideDuration={6000}
                      onClose={handleCloseSnackbar}
                      sx={{ marginTop: '10em', marginLeft: '10em' }}
                      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default DataQualityTab;